/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Col, Row } from "react-awesome-styled-grid";
import { Box } from "@nordcloud/gnui";
import { BreadcrumbsBox } from "~/components/BreadcrumbsBox";
import { ROUTES } from "~/routing/routes";
import { ResourceReportsTable } from "./components/ResourceReportsTable/ResourceReportsTable";

export function ResourceReports() {
  const breadcrumbsLabels = [
    { label: "Dashboard", uri: "/" },
    { label: "Reports", uri: ROUTES.resourcesV2.reports },
  ];

  return (
    <>
      <Row>
        <Col>
          <BreadcrumbsBox
            title="Reports"
            customBreadcrumbs={breadcrumbsLabels}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Box>
            <ResourceReportsTable />
          </Box>
        </Col>
      </Row>
    </>
  );
}
